<template>
  <v-dialog
    id="fullscreenDialog"
    fullscreen
    v-model="$store.getters.errorPage"
    hide-overlay
    transition="dialog-bottom-transition"
    :close-delay="500"
  >
    <div class="contentWrapper">
      <v-row justify="center"
             :class="{'py-10 mx-3': $vuetify.breakpoint.smAndUp, 'py-8 px-3': $vuetify.breakpoint.xsOnly}">
        <v-col cols="12" lg="7" md="7" sm="12" class="ma-0">
          <v-card min-height="390" class="pa-12 d-flex flex-column align-center">
            <FeatureIcon
              size="160"
              color="#041E42"
              background-color="#C8DCF0"
              icon="error_outline"
            />
            <h2 class="mt-6 mb-3" style="color: #041E42;">An error has occurred.</h2>
            <div :class="{'d-flex flex-column align-start': $vuetify.breakpoint.smAndUp}">
              <div v-html="$store.getters.errorMessage"></div>
              <p class="mb-0">Go back to <router-link to="/" class="hyperlinkAds">HOME</router-link> , or
                <a href="mailto:edpush@det.nsw.edu.au" class="hyperlinkAds">
                  contact support</a>.</p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
import {FeatureIcon} from '@nswdoe/doe-ui-core';

export default {
  name: 'Error',
  components: {
    FeatureIcon
  },
  data() {
    return {
      icon: "",
      errorMessage: ""
    }
  },
  created() {
    this.$store.commit('setErrorPage', true);
  }
}
</script>

<style scoped>
.contentWrapper {
  background-color: #F4F4F7;
  min-height: 100%;
  overflow-x: clip;
}

.hyperlinkAds {
  color: #1d428a !important;
  text-decoration: underline;
  font-weight: bold;
}
</style>
